import RevisionIcon from "assets/icon/RevisionIcon"

export default function UnDeleteButton(props){
    return(
        <button className={`button flex gap-2 ${ props?.visible ? 'block' : 'hidden' } hover:shadow-lg hover:opacity-85`} onClick={props?.onClick}>
            <RevisionIcon className="fill-white w-6" />
            <span>Undelete</span>
        </button>
    )
}